import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Division, SearchInputBox } from '../Commons';
import Authority from './Authority';

class AuthResultSearchForm extends Component {
  render() {
    const { division, handleSubmit, handleEntSubmit, text } = this.props;

    return (
      <Form className="top-form" style={{ padding: 16 }}>
        <Grid>
          <Grid.Row className="form-row">
            <Grid.Column width={10}>
              <Form.Group>
                <Division division={division} onChangeFunc={handleSubmit} />
              </Form.Group>
            </Grid.Column>

            <Grid.Column width={6}>
              <Form.Group>
                <Authority fnOnChange={handleSubmit} />
                <SearchInputBox
                  handleSubmit={handleSubmit}
                  handleEntSubmit={handleEntSubmit}
                  placeHolder={'ID, 이름'}
                />
              </Form.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

AuthResultSearchForm = connect((state) => ({
  // text: state.commons.text
}))(AuthResultSearchForm);

export default AuthResultSearchForm;
